import React from 'react';
import * as ReactDOM from "react-dom/client";
// bootstrap
import 'bootstrap';
// css
import './index.css';
import './scss/react.scss';
import 'primeicons/primeicons.css';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-teal/theme.css";

import { queryClient } from './utils/queryClient';
import { QueryClientProvider } from 'react-query';

import Router from './routes/app-route.jsx';

ReactDOM.createRoot(document.getElementById("root")).render(
	<QueryClientProvider client={queryClient}>
		<Router />
	</QueryClientProvider>
);